import { render } from "./vserviceuseredit.vue?vue&type=template&id=b7068ff0&scoped=true"
import script from "./vserviceuseredit.vue?vue&type=script&lang=js"
export * from "./vserviceuseredit.vue?vue&type=script&lang=js"

import "./vserviceuseredit.vue?vue&type=style&index=0&id=b7068ff0&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7068ff0"]])

export default __exports__